module.exports = __webpack_public_path__ + "static/logo-e041568d813fb7bbfe8c007b28ecfe6e.png";